// Firebase Configuration and Initialization
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getMessaging, Messaging, isSupported } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
    // apiKey: "AIzaSyCLi9mgIekIbkcZE939kqLYdgliReC_eC4",
    // authDomain: "vigo-chat-25d8a.firebaseapp.com",
    // projectId: "vigo-chat-25d8a",
    // storageBucket: "vigo-chat-25d8a.appspot.com",
    // messagingSenderId: "295579701030",
    // appId: "1:295579701030:web:145a71f7b6ce273c597be7",
    // measurementId: "G-4WSDF3K1H7"
     apiKey: "AIzaSyDQubYvzgTg_ogT9W9KBLhOW_UTn9EGL-w",
     authDomain: "jfcchat-f12d9.firebaseapp.com",
     projectId: "jfcchat-f12d9",
     storageBucket: "jfcchat-f12d9.firebasestorage.app",
     messagingSenderId: "408106435920",
     appId: "1:408106435920:web:8a20b9d29e2b7e7de91855",
     measurementId: "G-3TXVD4K7N8"
};

// Initialize Firebase
let app: FirebaseApp;
let analytics: Analytics | null = null;
let messaging: Messaging | null = null;

// Promise that resolves once Firebase Messaging is initialized (or null if unsupported).
// Awaiting this in NotificationService prevents a race condition where messaging is
// still null when initialize() runs because isSupported() hasn't resolved yet.
let messagingReadyPromise: Promise<Messaging | null> = Promise.resolve(null);

// Initialize Firebase app
if (typeof window !== 'undefined') {
    app = initializeApp(firebaseConfig);

    // Initialize Analytics (only in browser)
    try {
        analytics = getAnalytics(app);
        console.log('✅ Firebase Analytics initialized');
    } catch (error) {
        console.warn('⚠️ Firebase Analytics initialization failed:', error);
    }

    // Initialize Messaging (only if supported)
    messagingReadyPromise = isSupported()
        .then((supported) => {
            if (supported) {
                messaging = getMessaging(app);
                console.log('✅ Firebase Messaging initialized');
            } else {
                console.warn('⚠️ Firebase Messaging not supported in this browser');
            }
            return messaging;
        })
        .catch((error) => {
            console.error('❌ Firebase Messaging support check failed:', error);
            return null;
        });
}

export const messagingReady = messagingReadyPromise;
export { app, analytics, messaging };
